module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/main-visual-0ee7e17b18c673be9f199388e0c44db3.jpg";